import { fieldsTimeOutValue } from "components/Field/index";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { isIntegerValid, uniqueId } from "utils";

const IntegerField = ({
  value,
  setValue,
  valueError,
  setValueError,
  labelText,
  placeHolder,
}) => {
  const id = uniqueId();

  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (!initialLoad) {
        if (value === "") {
          setValueError("Cannot be empty");
        } else if (!isIntegerValid(value)) {
          setValueError("This is not a valid number");
        } else {
          setValueError("");
        }
      }
    }, fieldsTimeOutValue);
    return () => clearTimeout(timeOutId);
  }, [value]);

  const handleChange = (e) => {
    setValue(e.target.value);
    if (initialLoad) {
      setInitialLoad(false);
    }
  };

  return (
    <label
      htmlFor={`${id}_form_field-integer`}
      className="form__field__integer"
    >
      <b>{labelText || "Value"}</b>
      <input
        type="text"
        id={`${id}_form_field-integer`}
        value={value}
        onChange={handleChange}
        className={valueError && "input__error"}
        placeholder={placeHolder}
      />
      <span className={`input__error__message ${valueError && "show"}`}>
        {valueError}
      </span>
    </label>
  );
};

export default IntegerField;

IntegerField.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  valueError: PropTypes.string.isRequired,
  setValueError: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  placeHolder: PropTypes.string,
};
